export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1604028341/sushimodo/downloadAppButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1591377852/general/cflogo_black.png'
export const about = 'https://d2kr9r2myaxtp.cloudfront.net/about.webp'
export const logo = 'https://d2kr9r2myaxtp.cloudfront.net/logo.webp'
export const contactbg = 'https://d2kr9r2myaxtp.cloudfront.net/contactbg.webp'
export const foodGallery = 'https://d2kr9r2myaxtp.cloudfront.net/hero.jpg'
export const hero = 'https://d2kr9r2myaxtp.cloudfront.net/mainHero.jpg'
export const heroText = 'https://d2kr9r2myaxtp.cloudfront.net/heroText.png'
export const locationMap = 'https://d2kr9r2myaxtp.cloudfront.net/realMap.webp'
export const locationMapPM = 'https://d2kr9r2myaxtp.cloudfront.net/realMap.webp'
export const mobileAbout =
  'https://d2kr9r2myaxtp.cloudfront.net/mobileAbout.webp'
export const mobileContactbg =
  'https://d2kr9r2myaxtp.cloudfront.net/mobileContact.webp'
export const mobileHero = 'https://d2kr9r2myaxtp.cloudfront.net/mobileHero.webp'
export const mobileHeroText =
  'https://d2kr9r2myaxtp.cloudfront.net/mobileHeroText.png'
export const mobileMap = 'https://d2kr9r2myaxtp.cloudfront.net/mobileMap.webp'
export const mobileMapPM = 'https://d2kr9r2myaxtp.cloudfront.net/mobileMap.webp'
export const mobilePromotion =
  'https://d2kr9r2myaxtp.cloudfront.net/mobilePromo.webp'
export const orderPickupButton =
  'https://d2kr9r2myaxtp.cloudfront.net/orderButton.webp'
export const promotions = 'https://d2kr9r2myaxtp.cloudfront.net/promo.webp'
export const mobileMenu = 'https://d119dh5sx3r8y4.cloudfront.net/viewMenu.webp'
